import React, {useEffect} from "react";
import {Person} from "../../../services/interface/query/person";
import Score from "../../dashboard/credit-data/Score";
import EconomicValue from "../../dashboard/credit-data/EconomicValue";
import {useFindChartFinanceSummaryService} from "../../../services/apis/apiDashboard";

interface Props {
    person?: Person | null;
}
export default function CreditData({person}: Props) {
    const {
        mutate: findFinanceSummaryService,
        isPending: loadingFinanceSummaryService,
        data: successFinanceSummaryService,
    } = useFindChartFinanceSummaryService();

    useEffect(() => {
        if (person?.taxIdentificationNumber) {
            findFinanceSummaryService({identifier: person.taxIdentificationNumber})
        }
    }, [person]);

    return (
        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-3 items-center'}>
            <Score sri className={'!min-w-[200px]'} {...{person}}/>
            <EconomicValue
                loading={loadingFinanceSummaryService}
                type={'equity'}
                value={successFinanceSummaryService?.equity}
            />
        </div>
    )
}
